export const base = '/learning';
export const course = '/learning/:courseId(\\d+)';
export const course__tab = '/learning/:courseId(\\d+)/:tab';
export const course__task = '/learning/task/:taskId';
export const course__quiz__edit = '/learning/quiz/edit/:quizId';
export const course__quiz__review = '/learning/quiz/review/:quizId';
